<template>
  <!-- 4s店合作情况统计 -->
  <div class="cooperation-situation-statistics-container">
    <public-report-header @generate="generate" :version="version" :isLoad="loading">
      <div class="cake-list" v-loading="loading">
        <div v-for="i in 3" :key="i" ref="pieChart" class="cake"></div>
      </div>
    </public-report-header>
  </div>
</template>

<script>
import publicReportHeader from './public-report-header'
import Vue from 'vue'
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/pie')
require('echarts/lib/component/legend')
Vue.use(echarts)
export default {
  name: 'cooperationSituationStatistics',
  components: {publicReportHeader},
  data () {
    return {
      version: '',
      loading: false
    }
  },
  methods: {
    /**
     * @param {number} index 第几个图
     * @param {object} data 参数
     * */
    initPieChart (index, data) {
      let pieChart = echarts.init(this.$refs.pieChart[index])
      let option = {
        legend: {
          orient: 'vertical',
          left: 'left',
          data: data.legend
        },
        color: ['#00a65a', 'red', '#1E90FF', '#9900FF'],
        series: [
          {
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: data.series,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      pieChart.setOption(option)
    },
    /***
     * 生成
     * @param {Object} params 生成需要的参数
     * */
    async generate (params) {
      this.loading = true
      let list = []
      try {
        await this.$axios.post('/huaao-api/visualReport/normalAndSuspendWorkingNumber', params).then(res => {
          this.version = res.data.version
          let obj = {}
          if (res.data.count > 0 && res.data.notRelation !== undefined) {
            obj.legend = [
              `正常合作数:${res.data.normalNum} 占比:${((res.data.normalNum / res.data.count) * 100).toFixed(2) + '%'}`,
              `中止合作数:${res.data.suspendNum} 占比:${((res.data.suspendNum / res.data.count) * 100).toFixed(2) + '%'}`,
              `未建立合作关系经销商数量:${res.data.notRelation} 占比:${((res.data.notRelation / res.data.count) * 100).toFixed(2) + '%'}`
            ]
            obj.series = [
              {
                value: res.data.normalNum,
                name: `正常合作数:${res.data.normalNum} 占比:${((res.data.normalNum / res.data.count) * 100).toFixed(2) + '%'}`
              },
              {
                value: res.data.suspendNum,
                name: `中止合作数:${res.data.suspendNum} 占比:${((res.data.suspendNum / res.data.count) * 100).toFixed(2) + '%'}`
              },
              {
                value: res.data.notRelation,
                name: `未建立合作关系经销商数量:${res.data.notRelation} 占比:${((res.data.notRelation / res.data.count) * 100).toFixed(2) + '%'}`
              }
            ]
          } else if (res.data.count > 0) {
            obj.legend = [
              `正常合作数:${res.data.normalNum} 占比:${((res.data.normalNum / res.data.count) * 100).toFixed(2) + '%'}`,
              `中止合作数:${res.data.suspendNum} 占比:${((res.data.suspendNum / res.data.count) * 100).toFixed(2) + '%'}`
            ]
            obj.series = [
              {
                value: res.data.normalNum,
                name: `正常合作数:${res.data.normalNum} 占比:${((res.data.normalNum / res.data.count) * 100).toFixed(2) + '%'}`
              },
              {
                value: res.data.suspendNum,
                name: `中止合作数:${res.data.suspendNum} 占比:${((res.data.suspendNum / res.data.count) * 100).toFixed(2) + '%'}`
              }
            ]
          }
          list.push(obj)
        })
        await this.$axios.post('/huaao-api/visualReport/getNormalSalesRatioOfPartners', params).then(res => {
          let obj = {}
          if (res.data.count > 0) {
            obj.legend = [
              `当月销售件数0-10的经销商数量:${res.data.class0_10} 占比:${((res.data.class0_10 / res.data.count) * 100).toFixed(2) + '%'}`,
              `当月销售件数11-15的经销商数量:${res.data.class11_15} 占比:${((res.data.class11_15 / res.data.count) * 100).toFixed(2) + '%'}`,
              `当月销售件数16-20的经销商数量:${res.data.class16_20} 占比:${((res.data.class16_20 / res.data.count) * 100).toFixed(2) + '%'}`,
              `当月销售件数21及以上的经销商数量:${res.data.class21_} 占比:${((res.data.class21_ / res.data.count) * 100).toFixed(2) + '%'}`
            ]
            obj.series = [
              {
                value: res.data.class0_10,
                name: `当月销售件数0-10的经销商数量:${res.data.class0_10} 占比:${((res.data.class0_10 / res.data.count) * 100).toFixed(2) + '%'}`
              },
              {
                value: res.data.class11_15,
                name: `当月销售件数11-15的经销商数量:${res.data.class11_15} 占比:${((res.data.class11_15 / res.data.count) * 100).toFixed(2) + '%'}`
              },
              {
                value: res.data.class16_20,
                name: `当月销售件数16-20的经销商数量:${res.data.class16_20} 占比:${((res.data.class16_20 / res.data.count) * 100).toFixed(2) + '%'}`
              },
              {
                value: res.data.class21_,
                name: `当月销售件数21及以上的经销商数量:${res.data.class21_} 占比:${((res.data.class21_ / res.data.count) * 100).toFixed(2) + '%'}`
              }
            ]
          }
          list.push(obj)
        })
        list.forEach((e, i) => this.initPieChart(i, e))
        // 代表所有数据都为空
        if (list.filter(e => Object.keys(e).length === 0).length === list.length) {
          this.loading = false
          return this.$message.info('暂无数据')
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
  .cooperation-situation-statistics-container {
    height: 100%;
    width: 100%;
    background-color: #fff;

    .cake-list {
      height: 100%;
      overflow: auto;

      .cake {
        height: 600px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/custom/page/huaao/visualReport/cooperation-situation-statistics.vue